import { render, staticRenderFns } from "./TimetableCreate.vue?vue&type=template&id=2b23554e"
import script from "@/controllers/timetable/timetable-create.js?vue&type=script&lang=js&external"
export * from "@/controllers/timetable/timetable-create.js?vue&type=script&lang=js&external"
import style0 from "./TimetableCreate.vue?vue&type=style&index=0&id=2b23554e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports